/* import __COLOCATED_TEMPLATE__ from './sq-flash-message.hbs'; */
/**
# HI I AM SO DEPRECATED!! YOU SERIOUSLY DO NOT EVEN WANT TO GO HERE!

Check out Glass UI's [`flash` service](/glass/docs/development/flash.html) for all of your
interactive messaging needs! For static messaging, check out [`banner-static`](/components/glass/banner-static.html).

## SERIOUSLY DO NOT EVEN READ THE STUFF BELOW HERE

## Flash Message
`sq-flash-message` is our standardized way of handling success, info, and error level
messages.

Error and Warning messages stay on screen until either manually dismissed or dismissed
by the controller. Success and Info style flash messages (or toasts) automatically
disappear after a set time.

```example
@title Example of success banner

@controller-properties
{
  flashMessageType: 'SUCCESS',
  showFlashMessage: true,
  flashMessage: 'You have saved your settings.'
}

@hbs
{{deprecated/sq-flash-message type=flashMessageType
                   isActive=showFlashMessage
                   message=flashMessage}}

```

```example
@title Warning Flash Message (custom body)
@hbs
{{#deprecated/sq-flash-message isActive=true type="WARNING"}}
  This is a flash message warning with a custom body.
{{/deprecated/sq-flash-message}}
```

```example
@title Success Flash Message
@hbs
{{deprecated/sq-flash-message message="Your action was successful!"
                   type="SUCCESS"
                   isActive=true
                   class="your-custom-flash-class"}}
```

```example
@title Dismissible Example
@hbs
{{deprecated/sq-flash-message message="Dismissible Message"
                   type="SUCCESS"
                   isActive=true
                   dismiss=(action "dismiss")}}
```

### Parameters
@param {String} [type=null] The type of a flash message can be `ERROR`, `INFO`, `SUCCESS` or `WARNING`
@param {Boolean} [isActive=null] Set to `true` to show Flash message, `false` to hide.
@param {String} [message=null] Message shown in the flash message.
@param {Action} [dismiss=null] Optional dismiss action. If provided, a close icon will be rendered that simply calls this action on click, which is then responsible for updating whatever state is needed to dismiss the flash.
 */

import Component from '@ember/component';
import { computed } from '@ember/object';
import alertTriangleIconComponent from '@square/glass-ui/components/svg/icon-alert-triangle';
import checkmarkCircleIconComponent from '@square/glass-ui/components/svg/icon-checkmark-circle';
import infoCircleIconComponent from '@square/glass-ui/components/svg/icon-info-circle';
export const TYPE = {
  ERROR: 'ERROR',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING'
};

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['banner-flash'],
  classNameBindings: ['isActive:banner-flash--is-visible', 'typeClass'],
  shouldShowIcon: true,
  typeClass: computed('type', function () {
    switch (this.type) {
      case TYPE.ERROR:
        return 'banner-flash--is-error';
      case TYPE.INFO:
        return 'banner-flash--is-info';
      case TYPE.SUCCESS:
        return 'banner-flash--is-successful';
      case TYPE.WARNING:
        return 'banner-flash--is-warning';
      default:
        return '';
    }
  }),
  iconComponent: computed('type', function () {
    switch (this.type) {
      case TYPE.INFO:
        return infoCircleIconComponent;
      case TYPE.ERROR:
        return alertTriangleIconComponent;
      case TYPE.SUCCESS:
        return checkmarkCircleIconComponent;
      case TYPE.WARNING:
        return alertTriangleIconComponent;
      default:
        return infoCircleIconComponent;
    }
  }),
  iconColor: computed('type', function () {
    switch (this.type) {
      case TYPE.ERROR:
        return 'white';
      case TYPE.INFO:
        return 'blue-medium';
      case TYPE.SUCCESS:
        return 'white';
      case TYPE.WARNING:
        return 'base';
      default:
        return 'base';
    }
  }),
  actions: {
    dismiss() {
      if (this.dismiss) {
        this.dismiss();
      }
    }
  }
});